<script setup>

import { ref, watch, onMounted } from 'vue';

const { parametre, selectionne } = defineProps({
  parametre: Object,
  selectionne: Boolean
});

const composant = ref(null);

watch(() => selectionne, (sel) => {
	if (sel) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

onMounted(() => {
	if (composant.value != null && selectionne) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

</script>

<template>
	<div class="parametre" ref="composant">
		{{ parametre.nom }}
	</div>
</template>

<style scoped>

.parametre {
	overflow: hidden;
	text-overflow: ellipsis;
}

</style>